<template>
  <div>
    <div class="nav-bar">
      <el-button icon="el-icon-arrow-left"><router-link to="/counter" class="back-link">返回</router-link></el-button>
    </div>
    <vue-office-docx
      :src="docx"
    />
  </div>
</template>

<script>
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'

export default {
  components: {
    VueOfficeDocx
  },
  data() {
    return {
      showSendEmail: false,
      email: '',
      docx: require('@/assets/' + this.$route.query.fileName)
    }
  }
}
</script>

<style>
.nav-bar {
  display: flex;
  justify-content: space-between;
  top: 0;
  left: 0;
  padding: 10px;
}

.back-link {
  text-decoration: none;
}
</style>
